import React from "react";
import { Card, CardActions, CardContent, CardMedia, Button, Typography} from '@material-ui/core/';
import useStyles from './styles';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import DeleteIcon from '@material-ui/icons/Delete';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import ThumbUpAltOutlined from '@material-ui/icons/ThumbUpAltOutlined';
import moment from 'moment';
import { useDispatch } from 'react-redux';
// import useCommonStyles from './../../CommonStyle/commonStyle';
import { useHistory } from "react-router-dom";

import { deleteProject, likeProject } from '../../../actions/projects'

//@ts-ignore
const Project = ({ project, setCurrentId }) => {
    const classes = useStyles();
    // const commonClasses = useCommonStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const user = JSON.parse(localStorage.getItem('profile') || '{ "result": { "name": "","imageUrl": ""}}');

    const Likes = () => {
        if (project.likeCount !== undefined && project.likeCount.length > 0) {
            return project.likeCount.find((like: string) => like === (user?.result?.googleId || user?.result?._id))
                ? (
                    <><ThumbUpAltIcon fontSize="small" />&nbsp;{project.likeCount.length > 2 ? `You and ${project.likeCount.length - 1} others` : `${project.likeCount.length} like${project.likeCount.length > 1 ? 's' : ''}`}</>
                ) : (
                    <><ThumbUpAltOutlined fontSize="small" />&nbsp;{project.likeCount.length} {project.likeCount.length === 1 ? 'Like' : 'Likes'}</>
                );
        } else {
            console.log("projects was empty");
        }

        return <><ThumbUpAltOutlined fontSize="small" />&nbsp;Like</>;
    };

    // const openProject = () => { };
    const openProject = () => history.push(`/projects/${project._id}`);
    return (
        <Card className={classes.card}>

            <CardMedia className={classes.media} image={project.imageUrl || 'https://user-images.githubusercontent.com/194400/49531010-48dad180-f8b1-11e8-8d89-1e61320e1d82.png'} title={project.title} />

            <div className={classes.overlay}>
                {/* <Typography variant="h6">{project.name}</Typography> */}
                <Typography variant="body2">{moment(project.createdAt).fromNow()}</Typography>
            </div>
            {(user.result?.googleId === project?.creator || user?.result?._id === project?.creator) && (
                <div className={classes.overlay2}>
                    <Button onClick={() => setCurrentId(project._id)} style={{ color: 'white' }} size="small">
                        <MoreHorizIcon fontSize="medium" />
                    </Button>
                </div>
            )}
            {/* () => (JSON.parse(localStorage.getItem('profile') || 'result.name.length < 1 ? <Landing /> : <Redirect to="/startup/dashboard" />) */}


            <div className={classes.details}>
                <Typography variant="body2" color="textSecondary" component="h2">{project.tags.map((tag: string) => `#${tag} `)}</Typography>
            </div>
            {(project.title.length >14) &&
            (<Typography className={classes.title} gutterBottom variant="h5" component="h2"> {project.title.slice(0, 13)+" ..."}</Typography>)}
            {(project.title.length <15) &&
            (<Typography className={classes.title} gutterBottom variant="h5" component="h2"> {project.title}</Typography>)}
            <CardContent>
                <Typography variant="body2" color="textSecondary" component="p">{project.message.slice(0, 100)+"..."}</Typography>
            </CardContent>
            <Button onClick={openProject}>詳細</Button>
            <CardActions className={classes.cardActions}>
                <Button size="small" color="primary" disabled={!user?.result} onClick={() => dispatch(likeProject(project._id))}>
                    <Likes />
                </Button>
                {(user?.result?.googleId === project?.creator || user?.result?._id === project?.creator) && (
                    <Button size="small" color="secondary" onClick={() => dispatch(deleteProject(project._id))}>
                        <DeleteIcon fontSize="small" /> Delete
                    </Button>
                )}
                {/* <Button size="small" color="primary" onClick={() => dispatch(deletePost(post._id))}><DeleteIcon fontSize="small" /> Delete</Button> */}
            </CardActions>
            {/* </Grid> */}
            {/* <CardMedia className={classes.media} image={project.selectedFile || 'https://user-images.githubusercontent.com/194400/49531010-48dad180-f8b1-11e8-8d89-1e61320e1d82.png'} title={project.title} /> */}
        </Card>
    );
}

export default Project;